/* eslint-disable */
<template>
	<section class="full-height">
		<div
			style="position:fixed;top:40%;width:50px;background:transparent;height:200px;"
			v-on:click="prompt"
		></div>
		<div
			v-if="openOptions"
			style="background:#fff;position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999999999999999"
		>
			<div>
				<button class="button" v-on:click="reload">Neu Laden</button>
			</div>
			<div>
				<button v-on:click="callSumpUpLogin" class="button">SumUp Login</button>
			</div>

			<div>
				<button v-on:click="callSumUpSettings" class="button">SumUp Einstellungen</button>
			</div>
			<div>
				<button v-on:click="closeOptions" class="button">Schließen</button>
			</div>
		</div>
		<div class="welcome">Herzlich Willkommen</div>
		<div class="welcome-sub">im Friederike Wackler Gästehaus</div>
		<div class="has-text-centered full-width welcome-buttons">
			<router-link :to="{ name: 'bookingCode'}">
				<button class="button" style="line-height: 0.9em;">
					<span style="font-size:0.5em;">Ich habe einen</span>
					<br>Buchungscode
					<br>
					<span style="font-size:0.5em;line-height:0.4em;display:inline-block;">Hier tippen zum Eingeben</span>
				</button>
			</router-link>
			<!-- <router-link :to="{ name: 'roomSelect'}">
				<button class="button">
					<span style="font-size:0.5em;">Ich möchte ein</span>
					<br>Zimmer buchen
				</button>
			</router-link>-->
		</div>
		<div style="text-align:center;font-weight:bold;margin-top:3em;">
			<router-link
				:to="{ name: 'welcome'}"
				style="color:black;font-size:1.2em; "
			>Zimmer-Code vergessen?</router-link>
		</div>
		<div style="text-align:center;margin-top:8em;">
			<img class="accepted-payment" src="/static/visa_pos_fc.png" alt>
			<img class="accepted-payment" src="/static/mc_vrt_opt_pos_73_3x.png" alt>
			<img class="accepted-payment" src="/static/ms_vrt_opt_pos_73_3x.png" alt>
			<img class="accepted-payment" src="/static/mc_ec.png" alt>
			<img class="accepted-payment" src="/static/contactless_ind_pos.png" alt>
			<img class="accepted-payment" src="/static/Apple_Pay_Mark_RGB_LARGE_052318.png" alt>
			<img class="accepted-payment" src="/static/GooglePay_mark_800_gray_3x.png" alt>
		</div>
		<div class="support-bar">Hilfe oder Fragen? Telefon: &zwj;0151 - 61 &zwj;88 92 &zwj;27</div>
	</section>
</template>
<script>
export default {
	name: 'Welcome',

	components: {},

	data () {
		return {
			companies: [],
			openOptions: false
		}
	},

	created () {
		var booking = {}
		this.$store.commit('setBooking', booking)

		// this.$router.push({ name: 'maintenance' })
	},

	methods: {
		closeOptions () {
			this.openOptions = false
		},
		reload () {
			window.location.reload(true)
		},
		callSumpUpLogin () {
			console.log('click')
			window.webkit.messageHandlers['startLogin'].postMessage(
				'startLogin'
			)
		},
		callSumUpSettings () {
			window.webkit.messageHandlers['startSettings'].postMessage(
				'startSettings'
			)
		},
		prompt () {
			this.$dialog.prompt({
				message: `Bitte Authentifizieren.`,
				inputAttrs: {
					placeholder: 'Passwort',
					maxlength: 30
				},
				onCancel: () => {},
				onConfirm: value => {
					if (value === 'stuttgartberlin') {
						this.openOptions = true
					} else {
						this.$toast.open('Passwort falsch.')
					}
				}
			})
		}
	}
}
</script>
<style scoped>
.welcome {
	font-size: 6em;
	margin-top: 1em;
	font-weight: 900;
	text-align: center;
}
.welcome-sub {
	text-align: center;
	font-size: 2em;
	font-weight: bold;
}
.support-bar {
	text-align: center;
	font-size: 1.5em;
	margin-top: 4em;
	font-weight: bold;
}
.support-bar>* {
	color:black !important;
}
.support-corner {
	position: absolute;
	right: 2em;
	bottom: 1em;
	font-weight: 600;
	font-size: 2em;
}

.welcome-buttons {
	margin-top: 3em;
}
.button {
	padding: 0.5em 1.5em 0.75em 1.5em;
}

.support-corner a,
.support-bar a {
	color: black;
}
a[href^="tel"] {
	color: black;
}
.accepted-payment {
	height: 75px;
	margin-right: 0.25em;
}
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue